import { render, staticRenderFns } from "./IKImageS3Wrapper.vue?vue&type=template&id=2daa1b5d&scoped=true"
import script from "./IKImageS3Wrapper.vue?vue&type=script&lang=js"
export * from "./IKImageS3Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa1b5d",
  null
  
)

export default component.exports